<template>
  <IadStickySmallDevice>
    <IadBtn
      class="w-full"
      size="large"
      :text="$t(`core.navigation.find_agent`)"
      :to="{ name: 'find-real-estate-agent' }"
      @click="trackEvent({
        event: 'navigation',
        event_name: 'cta_click',
        cta_type: 'agent',
        cta_name: 'find_real_estate_agent',
      })"
    />
  </IadStickySmallDevice>
</template>
